/* script */
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import AccreditedLinks from 'ui/pages/settings/AccreditedLinks.vue';
import APITokens from 'ui/pages/user/APITokens.vue';
import AssetItemDetails from 'ui/pages/AssetItemDetails.vue';
import AssetsLibrary from 'ui/pages/AssetsLibrary.vue';
import AssistedSessionCheckIn from 'ui/components/session-check-in/AssistedSessionCheckIn.vue';
import BackstageIcons from 'shared/ui/components/dev-tools/BackstageIcons.vue';
import BadgePrintingSettings from 'ui/pages/printing/BadgePrintingSettings.vue';
import BrandedAppLegal from 'ui/components/branded-app/BrandedAppLegal.vue';
import ChangePassword from 'ui/pages/user/ChangePassword.vue';
import ContentHubsList from 'ui/pages/ContentHubsList.vue';
import CreativeDesigner from 'ui/pages/printing/CreativeDesigner.vue';
import DeletedDocs from 'shared/ui/components/dev-tools/DeletedDocs.vue';
import DocumentEditor from 'shared/ui/components/dev-tools/DocumentEditor.vue';
import EmailEditor from 'ui/pages/EmailEditor.vue';
import Empty from 'ui/pages/Empty.vue';
import EventDashboard from 'ui/pages/EventDashboard.vue';
import EventsList from 'ui/pages/EventsList.vue';
import FeedsList from 'ui/pages/FeedsList.vue';
import GenericForm from 'ui/pages/GenericForm.vue';
import GenericList from 'ui/pages/GenericList.vue';
import MeetingRequestList from 'ui/components/meetings/meeting-requests/MeetingRequestList.vue';
import MeetingRequestFormSettings from 'ui/components/meetings/meeting-requests/MeetingRequestFormSettings.vue';
import GenericPreferencesEditor from 'ui/pages/GenericPreferencesEditor.vue';
import LeadsSettings from 'ui/pages/leads/LeadsSettings.vue';
import LegalDocuments from 'ui/pages/organizations/LegalDocuments.vue';
import LiveSessionsList from 'ui/pages/live-stream/LiveSessionsList.vue';
import LiveStream from 'ui/pages/live-stream/LiveStream.vue';
import Mailing from 'ui/pages/emailing/Mailing.vue';
import Marketplace from 'ui/pages/Marketplace.vue';
import MeetingsCalendar from 'ui/pages/meetings/MeetingsCalendar.vue';
import MeetingsList from 'ui/pages/meetings/MeetingsList.vue';
import MeetingsSettings from 'ui/pages/meetings/MeetingsSettings.vue';
import MeetingRequestsSettings from 'ui/pages/meetings/MeetingRequestsSettings.vue';
import MetadataEditor from 'ui/pages/MetadataEditor.vue';
import OrganisationDetails from 'ui/pages/organizations/OrganisationDetails.vue';
import PackageInspector from 'shared/ui/components/dev-tools/PackageInspector.vue';
import PaxManager from 'ui/components/organizations/PaxManager.vue';
import PublicLoginI18n from 'shared/ui/components/dev-tools/PublicLoginI18n.vue';
import Registration from 'ui/pages/Registration.vue';
import PersonDisplay from 'ui/pages/types/Person.vue';
import ScheduledEmails from 'ui/pages/emailing/ScheduledEmails.vue';
import SelfSessionCheckin from 'ui/components/session-check-in/SelfSessionCheckin.vue';
import SessionsRegistrationConfiguration from 'ui/pages/registrations/SessionsRegistrationConfiguration.vue';
import ShortLinkExport from 'ui/pages/shortlinks/ShortLinkExport.vue';
import Suspended from 'ui/pages/Suspended.vue';
import TeamMembers from 'ui/pages/settings/TeamMembers.vue';
import TemplatesList from 'ui/pages/TemplatesList.vue';
import ThemeAssetsManager from 'ui/pages/theme/ThemeAssetsManager.vue';
import ThemeManager from 'ui/pages/theme/ThemeManager.vue';
import UserManagement from 'ui/pages/UserManagement.vue';
import UserProfile from 'ui/pages/user/Profile.vue';
import UsersList from 'shared/ui/components/listings/UsersList.vue';
import VideoLibrary from 'ui/pages/VideoLibrary.vue';
import VideoLibraryDetails from 'ui/pages/VideoLibraryDetails.vue';
import Webhooks from 'ui/pages/organizations/Webhooks.vue';
import WebinarsList from 'ui/pages/WebinarsList.vue';
import WebinarTemplateEditor from 'ui/pages/webinars/WebinarTemplateEditor.vue';
import WebinarTemplates from 'ui/pages/WebinarTemplates.vue';
import WordCloudBlockedWordsPreferences from 'ui/pages/live-stream/WordCloudBlockedWordsPreferences.vue';
import WorkspaceDefaultSettings from 'ui/pages/organizations/WorkspaceDefaultSettings.vue';
import WorkspaceSettings from 'ui/pages/settings/WorkspaceSettings.vue';

// TODO: remove this component when org-event-list and org-content-hub-list are migrated to Vue.
import CreateWorkspaceButton from 'ui/components/CreateWorkspaceButton.vue';
import EntitlementPlans from 'ui/components/organizations/entitlements/EntitlementPlans.vue';
// TODO : remove when lists with an upload button are migrated to vue
import UploadButton from 'shared/ui/components/uploader/UploadButton.vue';

/**
 * This is the main application wrapper, it works as the component that includes
 * pages controllers.
 *
 * @category ui.pages
 * @exports Page
 * @component
 */
const __vue_script__ = {
    name: 'Page',

    components: {
        AccreditedLinks,
        APITokens,
        AssetItemDetails,
        AssetsLibrary,
        AssistedSessionCheckIn,
        BackstageIcons,
        BadgePrintingSettings,
        BrandedAppLegal,
        ChangePassword,
        ContentHubsList,
        CreateWorkspaceButton,
        CreativeDesigner,
        DeletedDocs,
        DocumentEditor,
        EmailEditor,
        Empty,
        EntitlementPlans,
        EventDashboard,
        EventsList,
        FeedsList,
        GenericForm,
        GenericList,
        MeetingRequestList,
        MeetingRequestFormSettings,
        GenericPreferencesEditor,
        LeadsSettings,
        LegalDocuments,
        LiveSessionsList,
        LiveStream,
        Mailing,
        Marketplace,
        MeetingsCalendar,
        MeetingsList,
        MeetingsSettings,
        MeetingRequestsSettings,
        MetadataEditor,
        OrganisationDetails,
        PackageInspector,
        PaxManager,
        PublicLoginI18n,
        PersonDisplay,
        Registration,
        ScheduledEmails,
        SelfSessionCheckin,
        SessionsRegistrationConfiguration,
        ShortLinkExport,
        Suspended,
        TeamMembers,
        TemplatesList,
        ThemeAssetsManager,
        ThemeManager,
        UploadButton,
        UserManagement,
        UserProfile,
        UsersList,
        VideoLibrary,
        VideoLibraryDetails,
        Webhooks,
        WebinarsList,
        WebinarTemplateEditor,
        WebinarTemplates,
        WordCloudBlockedWordsPreferences,
        WorkspaceDefaultSettings,
        WorkspaceSettings
    },

    props: {
        user: {
            type: Object,
            required: true
        },

        blueprint: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            default: null
        },

        currentRoute: {
            type: Object,
            required: true
        },

        component: {
            type: String,
            required: true
        }
    },

    data() {
        let module = this.$services.blueprint.getModuleByName(this.blueprint.module.name);

        if (!module) {
            module = this.blueprint.module;
        }

        return {
            page: this.component,
            module,
            showNavs: true,
            tabs: [],
            params: {
                user: this.user,
                event: this.event,
                module: this.blueprint.module,
                currentController: get(this, 'blueprint.controller')
            },
        };
    },

    computed: {
        // Pass-through attributes
        /** @returns {object} */
        subProps() {
            return this.$root.subProps;
        },
        // Pass-through handlers
        /** @returns {object} */
        subHandlers() {
            return this.$root.subHandlers;
        },
        activeTabs() {
            const tabs = this.tabs.filter(tab => {
                return !tab.displayAsHelpItem && (!tab.hideNavUnlessActive || this.matchesRoute(tab));
            });
            return this.$utils.collections.sortByOrder(tabs);
        }
    },

    created() {
        this.$root.$on('route:update', (currentRoute) => {
            // params are extended with rootScope's `user` and `event` in `startVue` method
            const currentParams = currentRoute.params;

            currentParams.user = this.params.user;
            currentParams.event = this.params.event;
            currentParams.currentController = get(this, 'blueprint.controller');

            this.params = currentParams;
        });

        this.showNavs = !this.$services.user.isInvitedByLink(this.params.event);

        if (this.module.tabbed) {
            for (const ctrl of Object.keys(this.module.controllers)) {
                if (this.module.tabbed === true || this.module.tabbed.indexOf(ctrl) !== -1) {
                    const tabbedCtrl = { ...this.module.controllers[ctrl] };
                    tabbedCtrl.name = ctrl;

                    const addCtrl = !ctrl.roles || this.$services.user.matchesRoles(ctrl.roles);
                    if (addCtrl) {
                        this.tabs.push(tabbedCtrl);
                    }
                }
            }
        }
    },

    destroyed() {
        console.debug('[Page] Vue instance destroyed');
    },

    methods: {
        /**
         * Given a link this method checks if it matches with the current route.
         *
         * @private
         *
         * @param {Object} link the link on which perform the lookup
         * @param {Boolean} [perfectMatch=true] if the match must be perfect or partial
         *
         * @returns {Boolean} true if the link matches with the current route, false otherwise
         */
        matchesRoute(link, perfectMatch = true) {
            const searchParams = this.$router.getSearchParams();

            return this.$services.blueprint.matchRoute(this.currentRoute, searchParams, link, perfectMatch);
        },

        /**
         * Returns relative link for given module
         *
         * @param {Object} module
         *
         * @returns {String} relative link
         */
        getLink(module) {
            let link = module;

            if (!module.routes) {
                // module is category (1st level item)
                link = this.$services.menu.getFirstCategoryLink(module);
            }

            let params = this.$router.getRouteParams();
            let searchParams = {};

            // application menu links don't need any parameters
            // this is needed only for the event menu
            if (this.event) {
                params.eventId = this.event.id;
                searchParams = link.searchParams || {};
            }

            return this.$services.blueprint.getLinkForModule(link, params, searchParams);
        },

        /**
         * Clears the former component so that VueWrapper controller can fake
         * a `destroy` event on the vue instance.
         */
        clear() {
            this.page = 'Empty';
        },

        /** format the title */
        formatTitle(title) {
            return this.$utils.strings.humanize(title, true);
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "css-support",
          rawName: "v-css-support",
          value: {},
          expression: "{}",
        },
      ],
      staticClass: "page vue",
      class: _vm.$utils.strings.dasherize(_vm.page),
    },
    [
      _vm.activeTabs.length && _vm.showNavs
        ? _c(
            "ul",
            { staticClass: "nav nav-pills" },
            _vm._l(_vm.activeTabs, function (page) {
              return _c(
                "li",
                {
                  key: page.name,
                  staticClass: "nav-item",
                  class: [_vm.matchesRoute(page) ? "active" : ""],
                },
                [
                  _c("a", { attrs: { href: _vm.getLink(page) } }, [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(page.label) || _vm.formatTitle(page.title)
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        _vm.page,
        _vm._g(
          _vm._b(
            { tag: "component", attrs: { params: _vm.params } },
            "component",
            _vm.subProps,
            false
          ),
          _vm.subHandlers
        )
      ),
      _c("v-dialog"),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/Page.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__